import React, { Component } from 'react';
import serverClientUtil from '../../../../utils/serverClientUtil';

const MAX_ITEMS_TO_SHOW = 8;

const MoreItem = ({url}) => {
  return <div>
    <a
      href={`${serverClientUtil.getLPURL()}${url}`}
      target="_blank"
      className="showMoreLink"
      rel="noopener noreferrer"
      style={{ color: "var(--main-color-brand)" }}
    >
      Ver más +
    </a>
  </div>
};

class ItemInnerMainMenu extends Component {
  renderItem = (item, index) => {
    const key = `${item.name}-${index}`;

    return <div key={key}>
      <a
        href={`${serverClientUtil.getLPURL()}${item.url}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.name}
      </a>
    </div>
  }

  render() {
    const { data } = this.props;
    const displayList = (data && data.l3subcategories) ? data.l3subcategories : [];
    const hasMoreItems = displayList.length >= MAX_ITEMS_TO_SHOW;
    const maxItemsToShow = [...displayList].slice(0, MAX_ITEMS_TO_SHOW);

    return (
      <div key={data.name}>
        <h3 className="titleBlockOfSubProducts">
          {data.name}
        </h3>
        <div className="blockOfSubProducts">
          {maxItemsToShow.map(this.renderItem)}
          {hasMoreItems && <MoreItem url={data.url}/>}
        </div>
      </div>
    );
  }
}

export default ItemInnerMainMenu;
